import { Button, WandSparklesIcon } from '@buffer-mono/popcorn'

import styles from './AIPlaceholderButton.module.css'

import type { JSX } from 'react'

/**
 * This buttons is shown only as a placeholder when Editor is empty
 */
const AIPlaceholderButton = ({
  onToggle,
}: {
  onToggle: () => void
}): JSX.Element => {
  return (
    <Button
      variant="secondary"
      onClick={onToggle}
      id="ai-assistant-placeholder-button"
      data-testid="ai-assistant-placeholder-button"
      className={styles.placeholderButton}
      size="small"
    >
      <WandSparklesIcon className={styles.iconPurple} />
      Use the AI Assistant
    </Button>
  )
}

export { AIPlaceholderButton }
